import { useState, FormEvent } from "react";

interface LeadPopupProps {
  onClose: () => void;
  onSuccess: () => void;
}

export default function LeadPopup({ onClose, onSuccess }: LeadPopupProps) {
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    const form = e.currentTarget;
    const data = new URLSearchParams();
    data.append("Ad Soyad", (form.elements.namedItem("adSoyad") as HTMLInputElement).value);
    data.append("Telefon", (form.elements.namedItem("telefon") as HTMLInputElement).value);

    try {
      await fetch("https://readdy.ai/api/form/d782gfj2hsar0k5m04ag", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: data.toString(),
      });
      setSubmitted(true);
      setTimeout(() => { onSuccess(); }, 2000);
    } catch {
      setSubmitted(true);
      setTimeout(() => { onSuccess(); }, 2000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center px-4">
      {/* Overlay */}
      <div className="absolute inset-0 bg-[#1A0F0A]/70 backdrop-blur-sm" onClick={onClose} />

      {/* Popup Box */}
      <div
        className="relative bg-[#1A0F0A] rounded-2xl p-8 w-full max-w-md border border-[#E8B86D]/20"
        style={{ animation: "popupIn 0.35s cubic-bezier(0.34,1.56,0.64,1) both" }}
      >
        {/* Top accent */}
        <div className="absolute top-0 left-8 right-8 h-px bg-gradient-to-r from-transparent via-[#E8B86D]/60 to-transparent" />

        {/* Close */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full bg-white/10 text-white/60 hover:bg-white/20 transition-colors cursor-pointer"
        >
          <i className="ri-close-line text-base" />
        </button>

        {submitted ? (
          <div className="text-center py-6">
            <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#E8B86D]/15 mx-auto mb-4 border border-[#E8B86D]/30">
              <i className="ri-check-line text-3xl text-[#E8B86D]" />
            </div>
            <h3
              className="text-xl font-black italic text-white mb-2"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Teşekkürler!
            </h3>
            <p className="text-white/55 text-sm font-light">
              Bilgileriniz alındı. En kısa sürede sizinle iletişime geçeceğiz.
            </p>
          </div>
        ) : (
          <>
            {/* Icon */}
            <div className="w-14 h-14 flex items-center justify-center rounded-full bg-[#E8B86D]/15 mx-auto mb-5 border border-[#E8B86D]/30">
              <i className="ri-gift-line text-2xl text-[#E8B86D]" />
            </div>

            {/* Title */}
            <h3
              className="font-black italic text-white text-center mb-3 leading-tight"
              style={{
                fontFamily: "'Playfair Display', serif",
                fontSize: "1.6rem",
              }}
            >
              Size Özel Fırsatları
              <br />
              <span
                style={{
                  background: "linear-gradient(135deg, #C9943A, #E8B86D)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text",
                }}
              >
                Kaçırmayın
              </span>
            </h3>

            <p className="text-white/55 text-sm text-center leading-relaxed mb-7 font-light">
              En avantajlı kampanyalar ve özel indirimler için iletişim bilgilerinizi bırakın
            </p>

            {/* Form */}
            <form data-readdy-form onSubmit={handleSubmit} className="space-y-3">
              <div>
                <input
                  type="text"
                  name="adSoyad"
                  required
                  placeholder="Adınız ve Soyadınız"
                  className="w-full border border-white/20 rounded-xl px-4 py-3.5 text-sm text-white placeholder-white/40 focus:outline-none focus:border-[#E8B86D]/60 transition-all"
                  style={{ background: "rgba(255,255,255,0.07)" }}
                />
              </div>
              <div className="relative">
                <span className="absolute left-4 top-1/2 -translate-y-1/2 text-white/40 text-sm font-medium">
                  +90
                </span>
                <input
                  type="tel"
                  name="telefon"
                  required
                  placeholder="Telefon Numaranız"
                  className="w-full border border-white/20 rounded-xl pl-12 pr-4 py-3.5 text-sm text-white placeholder-white/40 focus:outline-none focus:border-[#E8B86D]/60 transition-all"
                  style={{ background: "rgba(255,255,255,0.07)" }}
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full bg-[#E8B86D] hover:bg-[#F5D08A] disabled:opacity-70 text-[#1A0F0A] font-black py-4 rounded-xl text-sm transition-all duration-200 cursor-pointer whitespace-nowrap flex items-center justify-center gap-2 mt-1"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                {loading ? (
                  <>
                    <i className="ri-loader-4-line animate-spin" />
                    Gönderiliyor...
                  </>
                ) : (
                  <>
                    Bilgi Al
                    <i className="ri-arrow-right-line" />
                  </>
                )}
              </button>
            </form>

            <p className="text-center text-white/25 text-xs mt-4 flex items-center justify-center gap-1 font-light">
              <i className="ri-lock-line" />
              Bilgileriniz güvende, spam göndermiyoruz
            </p>
          </>
        )}
      </div>

      <style>{`
        @keyframes popupIn {
          from { opacity: 0; transform: scale(0.88) translateY(20px); }
          to { opacity: 1; transform: scale(1) translateY(0); }
        }
      `}</style>
    </div>
  );
}